<template>
  <div style="padding:15px;" class="containerTable">
    <vxe-toolbar
      id="toolbarId_st12"
      :custom="{ storage: true }"
      export
      :refresh="{ query: RefreshList }"
    >
      <template v-slot:buttons>
        <el-button
          v-if="getLimit('sysConfig_search_button')"
          @click="funcFilter"
          >查询</el-button
        >
        <el-button v-if="getLimit('sysConfig_add_button')" @click="funcAdd"
          >新增</el-button
        >
        <el-button
          v-if="getLimit('sysConfig_export_button')"
          @click="funcExport"
          >导出</el-button
        >
      </template>
    </vxe-toolbar>
    <vxe-table
      ref="xTable"
      border
      show-footer
      resizable
      stripe
      highlight-current-row
      highlight-hover-row
      row-id="id"
      :loading="loading"
      class="mytable-footer"
      height="80%"
      :data="tableData"
      :sort-config="{ remote: true }"
      export-config
      show-overflow
      align="center"
      @sort-change="sortList"
    >
      <vxe-table-column type="checkbox" width="60" fixed="left" />
      <vxe-table-column>
        <vxe-table-column
          field="branchCode"
          title="承运主体"
          :formatter="formatterBranch"
          min-width="100"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.branchCode"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in branchList"
              :key="item.code"
              :label="item.groupName"
              :value="item.code"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="editType"
          title="可编辑类型"
          :formatter="formatterEditType"
          min-width="100"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.editType"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in editTypeOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="type"
          title="配置类型"
          min-width="100"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.type"
            placeholder="请输入配置类型"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="configKey"
          title="配置的key"
          min-width="100"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.configKey"
            placeholder="请输入配置的key"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="configValue"
          title="配置的value"
          min-width="100"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.configValue"
            placeholder="请输入配置的value"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="configDesc"
          title="配置描述"
          min-width="100"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.configDesc"
            placeholder="请输入配置描述"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column title="操作" fixed="right" min-width="120">
        <template slot-scope="scope">
          <el-tooltip
            v-if="getLimit('sysConfig_detail_button')"
            class="item"
            effect="dark"
            content="详情"
            placement="top"
          >
            <vxe-button type="text" @click="funcDetail(scope.row.code)">
              <i class="el-icon-document" />
            </vxe-button>
          </el-tooltip>
          <el-tooltip
            v-if="getLimit('sysConfig_edit_button')"
            class="item"
            effect="dark"
            content="编辑"
            placement="top"
          >
            <vxe-button type="text" @click="funcEdit(scope.row.code)">
              <i class="el-icon-edit" />
            </vxe-button>
          </el-tooltip>
          <el-tooltip
            v-if="getLimit('sysConfig_delete_button')"
            class="item"
            effect="dark"
            content="删除"
            placement="top"
          >
            <vxe-button type="text" @click="funcDelete(scope.row.code)">
              <i class="el-icon-delete" />
            </vxe-button>
          </el-tooltip>
        </template>
      </vxe-table-column>
    </vxe-table>
    <vxe-pager
      :loading="loading"
      :page-sizes="Pagingconf"
      :current-page.sync="listQuery.pageNum"
      :page-size.sync="listQuery.pageSize"
      :total="listQuery.total"
      :layouts="[
        'PrevJump',
        'PrevPage',
        'Number',
        'NextPage',
        'NextJump',
        'Sizes',
        'FullJump',
        'Total'
      ]"
      @page-change="handlePageChange"
    />

    <vxe-modal
      v-model="modelAddFlag"
      title="新增"
      width="860"
      height="560"
      resize
    >
      <compAdd
        ref="addRef"
        @fatherAddMethod="fatherAdd"
        @fatherCancelMethod="fatherCancel"
      />
    </vxe-modal>
    <vxe-modal
      v-model="modelEditFlag"
      title="编辑"
      width="860"
      height="560"
      resize
    >
      <compEdit
        ref="editRef"
        @fatherEditMethod="fatherEdit"
        @fatherCancelMethod="fatherCancel"
      />
    </vxe-modal>
    <vxe-modal
      v-model="modelDetailFlag"
      title="详情"
      width="860"
      height="560"
      resize
    >
      <compDetail ref="detailRef" />
    </vxe-modal>
    <downloadData ref="downloadRef" />
  </div>
</template>
<script>
import compAdd from "./components/partyGroupConfigAdd.vue";
import compEdit from "./components/partyGroupConfigEdit.vue";
import compDetail from "./components/partyGroupConfigDetail.vue";
import request from "@/utils/request";
export default {
  name: "PartyGroupConfigList",
  components: {
    compAdd,
    compEdit,
    compDetail
  },
  data() {
    return {
      message: "",
      loading: false,
      tableData: [],
      modelAddFlag: false,
      modelEditFlag: false,
      modelDetailFlag: false,
      copy: false,
      exportObj: {
        exportUrl:
          "/ntocc-basic-api/partyGroupConfig/exportPartyGroupConfigList", //导出接口
        name: "机构配置"
      },
      listQuery: {
        code: "",
        branchCode: "",
        editType: "",
        type: "",
        configKey: "",
        configValue: "",
        configDesc: "",
        pageNum: 1,
        pageSize: 20,
        sortField: "",
        sortType: "",
        total: 0
      },

      // 字段类型
      editTypeOptions: [
        { label: "客户", value: "custom" },
        { label: "中台", value: "platform" }
      ],
      // 机构列表
      branchList: this.$store.state.components.branchList
    };
  },
  created() {
    this.findList();
  },
  methods: {
    findList() {
      this.loading = true;
      return new Promise(resolve => {
        request({
          url: "/ntocc-basic-api/partyGroupConfig",
          method: "get",
          params: this.listQuery
        }).then(response => {
          this.tableData = response.data.records;
          this.listQuery.total = response.data.total;
          this.loading = false;
          resolve();
        });
      });
    },
    // 翻译机构
    formatterBranch({ cellValue }) {
      const item = this.branchList.find(item => item.code === cellValue);
      return item ? item.groupName : "";
    },
    // 翻译字段类型
    formatterEditType({ cellValue }) {
      const item = this.editTypeOptions.find(item => item.value === cellValue);
      return item ? item.label : "";
    },
    // 添加方法
    funcAdd() {
      this.$refs.addRef.$refs.form.resetFields();
      this.modelAddFlag = true;
    },
    // 修改方法
    funcEdit(code) {
      this.$refs.editRef.getInfo(code);
      this.modelEditFlag = true;
    },
    // 详情方法
    funcDetail(code) {
      this.$refs.detailRef.getInfo(code);
      this.modelDetailFlag = true;
    },
    // 删除方法
    funcDelete(row) {
      this.$confirm("确认删除吗？")
        .then(_ => {
          request({
            url: `/ntocc-basic-api/partyGroupConfig`,
            method: "delete",
            params: { codes: row }
          }).then(response => {
            this.$message({ message: response.msg, type: "success" });
            this.findList();
          });
        })
        .catch(_ => {});
    },
    // 增加组件的父方法
    fatherAdd() {
      this.modelAddFlag = false;
      this.findList();
    },
    // 编辑组件的父方法
    fatherEdit() {
      this.modelEditFlag = false;
      this.findList();
    },
    // 公共取消
    fatherCancel(modelFlag) {
      switch (modelFlag) {
        case "add":
          this.modelAddFlag = false;
          break;
        case "edit":
          this.modelEditFlag = false;
          break;
        case "detail":
          this.modelDetailFlag = false;
          break;
        default:
      }
    }
  }
};
</script>

<style>
.vxe-table .vxe-body--column:not(.col--ellipsis),
.vxe-table .vxe-footer--column:not(.col--ellipsis),
.vxe-table .vxe-header--column:not(.col--ellipsis) {
  padding: 6px 0;
}
.vxe-toolbar {
  padding: 0 0 10px 0;
}
</style>
